import { TFunction } from 'i18next'

/**
 * Parse GraphQL mutation error messages
 */
export default function getMutationErrorMessage(e: Error, t: TFunction) {
  if (e?.message?.includes('new row violates row-level security policy')) {
    return t('You do not have permission to perform this action')
  }

  if (
    e?.message?.includes(
      'new row for relation "form_field" violates check constraint "disallow_duplicate_form_field_names"',
    )
  ) {
    return t('Cannot create multiple custom fields with the same name')
  }

  if (e?.message?.startsWith('The value for this field must be unique.')) {
    const field = /\((.+)\)/.exec(e.message)?.[1]

    if (field) {
      return t('A user with this value already exists in {{field}}', {
        field: t(field),
      })
    }

    return t('The value for this field must be unique.')
  }

  return t('An unexpected error occured')
}
